import React from "react";
import "./searchIconNew.css";

const SearchIcon = () => {
  return <button type="submit" className="icon-search search__icon" />;
};

export default SearchIcon;
